import React, { Component } from 'react';
import styled from 'styled-components';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { verifyStripeAuthCode } from '../../../modules/Settings';

const Header = styled.h3`
  padding-left: 16px;
`;
const Container = styled.div`
  padding: 10px;
`;

class StripeCallback extends Component {
  async componentDidMount() {
    // get query parameters...
    const query = this.props.location.search.substring(1);
    const vars = query.split('&');
    let params = {};
    vars.forEach(v => {
      const pair = v.split('=');
      params[pair[0]] = pair[1];
    });

    let { code, state } = params;

    await this.props.verifyStripeAuthCode(code, state);
  }

  render() {
    const { isVerifying, verified } = this.props.settingsState;

    let message;
    if (isVerifying) {
      message = (
        <p>Please wait. We're verifying and connecting your Stripe account.</p>
      );
    }
    else if (!isVerifying && !verified) {
      message = (
        <p>Some sort of problem happened while connecting your Stripe account.</p>
      );
    }
    else if (!isVerifying && verified) {
      message = (
        <p>Your Stripe account is now connected!</p>
      );
    }

    return (
      <div>
        <Header>Settings / Stripe Account</Header>
        <Container>
          {message}
        </Container>
      </div>
    );
  }
}

function mapStateToProps(state) {
  return {
    settingsState: state.settingsState
  };
}

function mapDispatchToProps(dispatch) {
  return bindActionCreators({
    verifyStripeAuthCode: verifyStripeAuthCode,
  }, dispatch);
}

export default connect(mapStateToProps, mapDispatchToProps)(StripeCallback);
